<template>
  <div class="single-gift" :class="{ active: isActive }">
    <button class="btn btn-none select-indent" @click.prevent="selectGift">select</button>
    <div class="wrapp-content">
      <div class="card-code">
        <span class="value">{{gift.cardNumber}}</span>
      </div>
      <div class="card-amount">
        <span class="value">{{gift.balance | price($store) }}</span>
      </div>
    </div>
    <div class="block-remove" v-show="isActive">
      <button class="btn btn-none btn-remove-icon" type="button" @click.prevent="removeGift">
        <div class="wrapp-icon">
          <svg class="o-icon"><use xlink:href="#trash"></use></svg>
        </div>
      </button>
    </div>
  </div>
</template>

<script>
import { toast } from '@/modules/notifications'

export default {
  name: 'GiftTile',
  props: {
    gift: {
      type: Object,
      required: true
    },
    selected: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    isActive () {
      const _this = this
      return this.selected.find((sel) => sel.c_giftCertificateCode === _this.gift.cardNumber)
    },
    paymentIntrument () {
      if (this.isActive) {
        return this.isActive.payment_instrument_id
      } else {
        return ''
      }
    }
  },
  methods: {
    removeGift () {
      if (this.isActive) {
        return this.$emit('clicked', { cardNumber: this.gift.cardNumber, cardAmount: 0, paymentInstrumentId: this.paymentIntrument, add: false })
      } else {
        toast.error(this.$t('no-gift-id-found'))
      }
    },
    selectGift () {
      return this.$emit('clicked', { cardNumber: this.gift.cardNumber, cardAmount: parseFloat(this.gift.balance), paymentInstrumentId: this.paymentIntrument, add: !this.isActive })
    }
  }
}
</script>
